import { isAxiosError } from 'axios';

type ApiErrorMessageOptions = {
  includeStatusCode?: boolean;
};

type ApiErrorPayload = {
  message?: unknown;
  statusCode?: unknown;
};

const getApiErrorPayload = (value: unknown): ApiErrorPayload => {
  if (value && typeof value === 'object') {
    return value;
  }

  return {};
};

const getStringMessage = (value: unknown): string | undefined => {
  if (typeof value === 'string' && value.length > 0) {
    return value;
  }

  return undefined;
};

const getStatusCode = (value: unknown): number | undefined => {
  if (typeof value === 'number') {
    return value;
  }

  const parsedValue = Number(value);
  if (Number.isFinite(parsedValue)) {
    return parsedValue;
  }

  return undefined;
};

export const getApiErrorMessage = (
  error: unknown,
  fallback: string,
  options?: ApiErrorMessageOptions
): string => {
  if (isAxiosError(error)) {
    const payload = getApiErrorPayload(error.response?.data);
    const responseMessage = getStringMessage(payload.message);

    if (options?.includeStatusCode) {
      const statusCode =
        getStatusCode(payload.statusCode) ??
        getStatusCode(error.response?.status);
      const responseError = getStringMessage(payload.error);
      const message = responseMessage ?? responseError ?? fallback;

      if (statusCode !== undefined) {
        return `Error ${statusCode} : ${message}`;
      }

      return message;
    }

    return responseMessage || getStringMessage(payload.error) || error.message || fallback;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return fallback;
};
